import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
import { Lazyload } from 'vant';
import { AddressEdit } from 'vant';
import VueWechatTitle from 'vue-wechat-title'

Vue.config.productionTip = false;

Vue.use(Vant);
Vue.use(Lazyload);
Vue.use(AddressEdit);

Vue.use(VueWechatTitle)

new Vue({
  el: '#app',
  router,
  render: h => h(App)
}).$mount('#app');

